import * as actionTypes from "./actionTypes";
import axios from "../../http/axios";

const getCustomersSuccess = data => {
  return {
    type: actionTypes.GET_CUSTOMERS_LIST_SUCCESS,
    payload: data
  };
};

const getFreeDriverSuccess = data => {
    return {
        type: 'GET_FREE_DRIVER_SUCCESS',
        payload: data
    };
};

const getCustomersFailed = error => {
  return {
    type: actionTypes.GET_CUSTOMERS_LIST_FAIL,
    error: error
  };
};

export const getCustomers = (page = 1, searchValue) => {
  return (dispatch, getState) => {
    let url = `/customers/?page=${page}`;
    if (searchValue) {
      url = `${url}&search=${searchValue}`;
    }
    let token = getState().auth.token;
    const doesRemember = getState().auth.doesRemember;
    if (doesRemember) {
      token = localStorage.getItem("token");
    }
    axios
      .get(url, {
        headers: { Authorization: "JWT " + token }
      })
      .then(response => {
        dispatch(getCustomersSuccess(response.data));
      })
      .catch(error => {
        if (error.response && error.response.status === 403) {
          dispatch({ type: actionTypes.AUTH_SIGNOUT });
        } else {
          dispatch(getCustomersFailed(error));
        }
      });
  };
};

export const changeDeleteStatus = id => {
  return (dispatch, getState) => {
    let token = getState().auth.token;
    const doesRemember = getState().auth.doesRemember;
    if (doesRemember) {
      token = localStorage.getItem("token");
    }
    const url = `/customers/${id}/`;
    return axios
      .patch(
        url,
        { is_deleted: true },
        {
          headers: { Authorization: "JWT " + token }
        }
      )
      .then(res => res)
      .catch(error => {
        if (error.response && error.response.status === 403) {
          dispatch({ type: actionTypes.AUTH_SIGNOUT });
        }
      });
  };
};

export const assign = (alertId, data) => {
    return (dispatch, getState) => {
        let token = getState().auth.token;
        const doesRemember = getState().auth.doesRemember;
        if (doesRemember) {
            token = localStorage.getItem("token");
        }
        const url = `orders/assign-driver-by-admin/`;
        return axios.post( url, data, { headers: { Authorization: "JWT " + token } } ).then(res => {
           return axios.patch(`/alerts/${alertId}/`, { status: 'finished' }, {
                headers: { Authorization: "JWT " + token }
            })
                .then(resp => {
                    dispatch({ type: 'ASSIGN_ERROR', assignError  : false });
                    return 'done';
                })
                .catch(error => {
                    if (error.response && error.response.status === 403) {
                        dispatch({ type: actionTypes.AUTH_SIGNOUT });
                    }
                });

        })
            .catch(error => {
                if (error.response && error.response.status === 403) {
                    dispatch({ type: actionTypes.AUTH_SIGNOUT });
                }
                dispatch({ type: 'ASSIGN_ERROR', assignError  : true });
            });
    };
};


export const deleteCustomer = id => {
  return (dispatch, getState) => {
    let token = getState().auth.token;
    const doesRemember = getState().auth.doesRemember;
    if (doesRemember) {
      token = localStorage.getItem("token");
    }
    return axios
      .delete(`/customers/${id}/`, {
        headers: { Authorization: "JWT " + token }
      })
      .then(res => res)
      .catch(error => {
        if (error.response && error.response.status === 403) {
          dispatch({ type: actionTypes.AUTH_SIGNOUT });
        }
      });
  };
};

const getSingleCustomerSuccess = data => {
  return {
    type: actionTypes.GET_SINGLE_CUSTOMER_SUCCESS,
    payload: data
  };
};

const getSingleFailed = error => {
  return {
    type: actionTypes.GET_SINGLE_CUSTOMER_FAIL,
    error: error
  };
};

export const getCustomer = id => {
  return (dispatch, getState) => {
    dispatch({
      type: "START_GET_CUSTOMER"
    });
    let token = getState().auth.token;
    const doesRemember = getState().auth.doesRemember;
    if (doesRemember) {
      token = localStorage.getItem("token");
    }
    return axios
      .get("/customers/" + id + "/", {
        headers: { Authorization: "JWT " + token }
      })
      .then(response => {
        dispatch(getSingleCustomerSuccess(response.data));
        return Promise.resolve();
      })
      .catch(error => {
        if (error.response && error.response.status === 403) {
          dispatch({ type: actionTypes.AUTH_SIGNOUT });
        } else {
          dispatch(getSingleFailed(error));
        }
        return Promise.reject();
      });
  };
};

const addCustomerFailed = error => {
  return {
    type: actionTypes.ADD_CUSTOMER_FAILED,
    error: error
  };
};

export const eraseAssignError = () => {
    return (dispatch, getState) => {
        dispatch({ type: 'ASSIGN_ERROR', assignError: false });
    };
};

export const addCustomer = data => {
  return (dispatch, getState) => {
    const url = "/customers/";
    let token = getState().auth.token;
    const doesRemember = getState().auth.doesRemember;
    if (doesRemember) {
      token = localStorage.getItem("token");
    }
    const headers = { headers: { Authorization: "JWT " + token } };
    return axios
      .post(url, data, headers)
      .then(res => res)
      .catch(error => {
        if (error.response && error.response.status === 403) {
          dispatch({ type: actionTypes.AUTH_SIGNOUT });
        }
      });
  };
};

export const editCustomer = (id, data) => {
  return (dispatch, getState) => {
    const url = `/customers/${id}/`;
    let token = getState().auth.token;
    const doesRemember = getState().auth.doesRemember;
    if (doesRemember) {
      token = localStorage.getItem("token");
    }
    const headers = { headers: { Authorization: "JWT " + token } };
    return axios
      .patch(url, data, headers)
      .then(res => res)
      .catch(error => {
        if (error.response && error.response.status === 403) {
          dispatch({ type: actionTypes.AUTH_SIGNOUT });
        }
        return error;
      });
  };
};

const getCuisinesFailedSuccess = data => {
  return {
    type: actionTypes.GET_CUISINE_SUCCESS,
    payload: data
  };
};

const getCuisinesFailed = error => {
  return {
    type: actionTypes.GET_CUISINE_FAILED,
    error: error
  };
};

export const getCuisines = () => {
  return (dispatch, getState) => {
    const url = `/cuisines/?show_all=true`;
    let token = getState().auth.token;
    const doesRemember = getState().auth.doesRemember;
    if (doesRemember) {
      token = localStorage.getItem("token");
    }
    const headers = { headers: { Authorization: "JWT " + token } };
    axios
      .get(url, headers)
      .then(response => {
        dispatch(getCuisinesFailedSuccess(response.data));
      })
      .catch(error => {
        if (error.response && error.response.status === 403) {
          dispatch({ type: actionTypes.AUTH_SIGNOUT });
        } else {
          dispatch(getCuisinesFailed(error));
        }
      });
  };
};

const getFoodCategoriesSuccess = data => {
  return {
    type: actionTypes.GET_FOOD_CATEGORIES_SUCCESS,
    payload: data
  };
};

const getTagsSuccess = data => {
  return {
    type: actionTypes.GET_TAGS_SUCCESS,
    payload: data
  };
};

const getFoodCategoriesFailed = error => {
  return {
    type: actionTypes.GET_FOOD_CATEGORIES_FAILED,
    error: error
  };
};

export const getFoodCategories = () => {
  return (dispatch, getState) => {
    const url = `/food-categories/?show_all=true`;
    let token = getState().auth.token;
    const doesRemember = getState().auth.doesRemember;
    if (doesRemember) {
      token = localStorage.getItem("token");
    }
    const headers = { headers: { Authorization: "JWT " + token } };
    axios
      .get(url, headers)
      .then(response => {
        dispatch(getFoodCategoriesSuccess(response.data));
      })
      .catch(error => {
        if (error.response && error.response.status === 403) {
          dispatch({ type: actionTypes.AUTH_SIGNOUT });
        } else {
          dispatch(getFoodCategoriesFailed(error));
        }
      });
  };
};

const getZonesSuccess = data => {
  const modifiedData = data.results.map(item => {
    return {
      key: item.name,
      value: item.id
    };
  });
  return {
    type: actionTypes.GET_ZONES_SUCCESS,
    payload: modifiedData
  };
};

const getMenuSuccess = data => {
  return {
    type: actionTypes.GET_MENU_SUCCESS,
    payload: data
  };
};

const getListItemsSuccess = data => {
  return {
    type: actionTypes.GET_LIST_ITEMS_SUCCESS,
    payload: data
  };
};

const getItemsSuccess = data => {
  return {
    type: actionTypes.GET_ITEMS_SUCCESS,
    payload: data
  };
};

const getZonesFailed = error => {
  return {
    type: actionTypes.GET_ZONES_FAILED,
    error: error
  };
};

export const getZones = () => {
  return (dispatch, getState) => {
    const url = `/zones/?show_all=true`;
    let token = getState().auth.token;
    const doesRemember = getState().auth.doesRemember;
    if (doesRemember) {
      token = localStorage.getItem("token");
    }
    const headers = { headers: { Authorization: "JWT " + token } };
    axios
      .get(url, headers)
      .then(response => {
        dispatch(getZonesSuccess(response.data));
      })
      .catch(error => {
        if (error.response && error.response.status === 403) {
          dispatch({ type: actionTypes.AUTH_SIGNOUT });
        } else {
          dispatch(getZonesFailed(error));
        }
      });
  };
};

export const addMenu = data => {
  return (dispatch, getState) => {
    const url = `/menu/`;
    let token = getState().auth.token;
    const doesRemember = getState().auth.doesRemember;
    if (doesRemember) {
      token = localStorage.getItem("token");
    }
    const headers = { headers: { Authorization: "JWT " + token } };
    return axios
      .post(url, data, headers)
      .then(res => res)
      .catch(error => {
        if (error.response && error.response.status === 403) {
          dispatch({ type: actionTypes.AUTH_SIGNOUT });
        }
      });
  };
};

export const getMenuName = id => {
    return (dispatch, getState) => {
        dispatch({type: 'MENU_NAME_START'})
        const url = `/menu/${id}`;
        let token = getState().auth.token;
        const doesRemember = getState().auth.doesRemember;
        if (doesRemember) {
            token = localStorage.getItem("token");
        }
        const headers = { headers: { Authorization: "JWT " + token } };
        return axios
            .get(url, headers)
            .then(res => dispatch({type: 'MENU_NAME', payload: res.data.name_en}))
            .catch(error => {
                if (error.response && error.response.status === 403) {
                    dispatch({ type: actionTypes.AUTH_SIGNOUT });
                }
            });
    };
};

export const addItem = data => {
  return (dispatch, getState) => {
    const url = `/items/`;
    let token = getState().auth.token;
    const doesRemember = getState().auth.doesRemember;
    if (doesRemember) {
      token = localStorage.getItem("token");
    }
    const headers = { headers: { Authorization: "JWT " + token } };
    return axios
      .post(url, data, headers)
      .then(res => res)
      .catch(error => {
        if (error.response && error.response.status === 403) {
          dispatch({ type: actionTypes.AUTH_SIGNOUT });
        }
      });
  };
};

export const editMenu = (id, data) => {
  return (dispatch, getState) => {
    const url = `/menu/${id}/`;
    let token = getState().auth.token;
    const doesRemember = getState().auth.doesRemember;
    if (doesRemember) {
      token = localStorage.getItem("token");
    }
    const headers = { headers: { Authorization: "JWT " + token } };
    return axios
      .patch(url, data, headers)
      .then(res => res)
      .catch(error => {
        if (error.response && error.response.status === 403) {
          dispatch({ type: actionTypes.AUTH_SIGNOUT });
        }
      });
  };
};

export const editList = (id, data) => {
  return (dispatch, getState) => {
    const url = `/list/${id}/`;
    let token = getState().auth.token;
    const doesRemember = getState().auth.doesRemember;
    if (doesRemember) {
      token = localStorage.getItem("token");
    }
    const headers = { headers: { Authorization: "JWT " + token } };
    return axios
      .patch(url, data, headers)
      .then(res => res)
      .catch(error => {
        if (error.response && error.response.status === 403) {
          dispatch({ type: actionTypes.AUTH_SIGNOUT });
        }
      });
  };
};

export const editItem = (id, data) => {
  return (dispatch, getState) => {
    const url = `/items/${id}/`;
    let token = getState().auth.token;
    const doesRemember = getState().auth.doesRemember;
    if (doesRemember) {
      token = localStorage.getItem("token");
    }
    const headers = { headers: { Authorization: "JWT " + token } };
    return axios
      .patch(url, data, headers)
      .then(res => res)
      .catch(error => {
        if (error.response && error.response.status === 403) {
          dispatch({ type: actionTypes.AUTH_SIGNOUT });
        }
      });
  };
};

export const getMenu = restaurantId => {
  return (dispatch, getState) => {
    let url = `/menu/`;
    if (restaurantId) {
      url = `${url}?restaurant=${restaurantId}`;
    }
    let token = getState().auth.token;
    const doesRemember = getState().auth.doesRemember;
    if (doesRemember) {
      token = localStorage.getItem("token");
    }
    const headers = { headers: { Authorization: "JWT " + token } };
    return axios
      .get(url, headers)
      .then(response => {
        dispatch(getMenuSuccess(response.data));
      })
      .catch(error => {
        if (error.response && error.response.status === 403) {
          dispatch({ type: actionTypes.AUTH_SIGNOUT });
        }
      });
  };
};


export const getFreeDrivers = id => {
    return (dispatch, getState) => {
        let url = `/orders/nearly-drivers/${id}/`;
        let token = getState().auth.token;
        const doesRemember = getState().auth.doesRemember;
        if (doesRemember) {
            token = localStorage.getItem("token");
        }
        const headers = { headers: { Authorization: "JWT " + token } };
        return axios
            .get(url, headers)
            .then(response => {
                dispatch(getFreeDriverSuccess(response.data));
            })
            .catch(error => {
                if (error.response && error.response.status === 403) {
                    dispatch({ type: actionTypes.AUTH_SIGNOUT });
                }
            });
    };
};

export const addMenuList = data => {
  return (dispatch, getState) => {
    const url = `/list/`;
    let token = getState().auth.token;
    const doesRemember = getState().auth.doesRemember;
    if (doesRemember) {
      token = localStorage.getItem("token");
    }
    const headers = { headers: { Authorization: "JWT " + token } };
    return axios
      .post(url, data, headers)
      .then(res => res)
      .catch(error => {
        if (error.response && error.response.status === 403) {
          dispatch({ type: actionTypes.AUTH_SIGNOUT });
        }
      });
  };
};

export const addMenuItem = data => {
  return (dispatch, getState) => {
    const url = `/items/`;
    let token = getState().auth.token;
    const doesRemember = getState().auth.doesRemember;
    if (doesRemember) {
      token = localStorage.getItem("token");
    }
    const headers = { headers: { Authorization: "JWT " + token } };
    return axios
      .post(url, data, headers)
      .then(res => res)
      .catch(error => {
        if (error.response && error.response.status === 403) {
          dispatch({ type: actionTypes.AUTH_SIGNOUT });
        }
      });
  };
};

export const addTag = data => {
  return (dispatch, getState) => {
    const url = `/tags/`;
    let token = getState().auth.token;
    const doesRemember = getState().auth.doesRemember;
    if (doesRemember) {
      token = localStorage.getItem("token");
    }
    const headers = { headers: { Authorization: "JWT " + token } };
    return axios
      .post(url, data, headers)
      .then(res => res)
      .catch(error => {
        if (error.response && error.response.status === 403) {
          dispatch({ type: actionTypes.AUTH_SIGNOUT });
        }
      });
  };
};

export const removeTag = id => {
  return (dispatch, getState) => {
    const url = `/tags/${id}`;
    let token = getState().auth.token;
    const doesRemember = getState().auth.doesRemember;
    if (doesRemember) {
      token = localStorage.getItem("token");
    }
    const headers = { headers: { Authorization: "JWT " + token } };
    return axios
      .delete(url, headers)
      .then(res => res)
      .catch(error => {
        if (error.response && error.response.status === 403) {
          dispatch({ type: actionTypes.AUTH_SIGNOUT });
        }
      });
  };
};

export const getTags = () => {
  return (dispatch, getState) => {
    let url = `/tags/`;
    let token = getState().auth.token;
    const doesRemember = getState().auth.doesRemember;
    if (doesRemember) {
      token = localStorage.getItem("token");
    }
    const headers = { headers: { Authorization: "JWT " + token } };
    return axios
      .get(url, headers)
      .then(response => {
        dispatch(getTagsSuccess(response.data));
      })
      .catch(error => {
        if (error.response && error.response.status === 403) {
          dispatch({ type: actionTypes.AUTH_SIGNOUT });
        }
      });
  };
};

export const getListItems = (menuId, page = 1, searchValue) => {
  return (dispatch, getState) => {
    let url = `/list/?page=${page}`;
    if (menuId) {
      url = `${url}&menu=${menuId}`;
    }
    if (searchValue) {
      url = `${url}&search=${searchValue}`;
    }
    let token = getState().auth.token;
    const doesRemember = getState().auth.doesRemember;
    if (doesRemember) {
      token = localStorage.getItem("token");
    }
    const headers = { headers: { Authorization: "JWT " + token } };
    return axios
      .get(url, headers)
      .then(response => {
        dispatch(getListItemsSuccess(response.data));
      })
      .catch(error => {
        if (error.response && error.response.status === 403) {
          dispatch({ type: actionTypes.AUTH_SIGNOUT });
        }
      });
  };
};

export const getItems = (menuId, page = 1, searchValue) => {
  return (dispatch, getState) => {
    let url = `/items/?page=${page}`;
    if (menuId) {
      url = `${url}&menu=${menuId}`;
    }
    if (searchValue) {
      url = `${url}&search=${searchValue}`;
    }
    let token = getState().auth.token;
    const doesRemember = getState().auth.doesRemember;
    if (doesRemember) {
      token = localStorage.getItem("token");
    }
    const headers = { headers: { Authorization: "JWT " + token } };
    return axios
      .get(url, headers)
      .then(response => {
        dispatch(getItemsSuccess(response.data));
      })
      .catch(error => {
        if (error.response && error.response.status === 403) {
          dispatch({ type: actionTypes.AUTH_SIGNOUT });
        }
      });
  };
};

export const addListItem = data => {
  return (dispatch, getState) => {
    const url = `/list/`;
    let token = getState().auth.token;
    const doesRemember = getState().auth.doesRemember;
    if (doesRemember) {
      token = localStorage.getItem("token");
    }
    const headers = { headers: { Authorization: "JWT " + token } };
    return axios
      .post(url, data, headers)
      .then(res => res)
      .catch(error => {
        if (error.response && error.response.status === 403) {
          dispatch({ type: actionTypes.AUTH_SIGNOUT });
        }
      });
  };
};



// WEBPACK FOOTER //
// ./src/store/actions/customer.js